import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CodeEditorService {
  validations = signal(null);

  query = signal('');

  private readonly refreshEditor$: BehaviorSubject<{ refresh: boolean }> = new BehaviorSubject<{ refresh: boolean }>({
    refresh: false,
  });

  setValidations(validations: any) {
    this.validations.set(validations);
  }

  setQuery(query: string) {
    this.query.set(query);
  }

  refreshEditor(): void {
    this.refreshEditor$.next({ refresh: true });
  }

  isRefreshEditor() {
    return this.refreshEditor$.asObservable();
  }
}
